import React from 'react'
import {Box, Button, Flex, Image, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import arrowImage from '../../../../../../../assets/images/acquisition_decision_arrow.svg'
import useFeatureFlags from '../../../../../hooks/useFeatureFlags'
import {useAcquisitionDecision} from '../../../../../hooks/useAcquisitionDecision'
import PendingReasons from '../../../../../components/PendingReasons'

const Pending = () => {
  const {t} = useTranslation('onboarding')

  const {
    data: {features},
    loading: loadingFeatures,
  } = useFeatureFlags()

  const {data, transitionTo} = useAcquisitionDecision()

  return (
    <Flex
      p={{base: 'sm', lg: 'lg'}}
      flexDirection="column"
      justify="space-between"
      height="100%"
    >
      <Flex flexDirection="column" gap="md">
        <Text textStyle="caption">
          {t('onboarding:AcquisitionDecisionPending.subHeading')}
        </Text>
        <Text textStyle="headline2" fontSize={{base: '2xl', lg: '48px'}}>
          {t('onboarding:AcquisitionDecisionPending.heading')}
        </Text>
      </Flex>

      <Flex flexDirection="column" gap="md">
        <Flex borderBottom="1px" px="0" py="md" align="center">
          <Image
            src={arrowImage}
            width="32px"
            height="32px"
            mr="sm"
            display={{base: 'none', sm: 'block'}}
          />
          <Box
            as="span"
            flex="1"
            textAlign="left"
            textStyle="headline4"
            fontSize={{base: 'md', md: 'lg'}}
            textTransform="uppercase"
          >
            {t('onboarding:AcquisitionDecisionPending.accordionButtonLabel')}
          </Box>
        </Flex>
        <Box mx={{base: '0', lg: 'lg'}}>
          <PendingReasons pendingReasonKeys={data.pendingReasonKeys} />

          <Text textStyle="headline5" textTransform="uppercase">
            {t('onboarding:AcquisitionDecisionPending.accordionPanelFooter')}
          </Text>
        </Box>
        {!loadingFeatures && features.getToKnowMarmalde && (
          <Box
            border="1px solid"
            borderColor="mld.neutral.700"
            borderRadius="5px"
            padding="25px"
            marginTop="20px"
            backgroundColor="mld.neutral.800"
          >
            <Flex
              justify="space-between"
              align="center"
              flexDirection={{md: 'row', sm: 'column'}}
            >
              <Box>
                <Text
                  textTransform="uppercase"
                  textStyle="headline3"
                  paddingBottom="15px"
                >
                  {t(
                    'onboarding:AcquisitionDecisionPending.getToKnowMarmaladeHeading',
                  )}
                </Text>
                <Text paddingBottom={{md: '0px', sm: '10px'}}>
                  {t(
                    'onboarding:AcquisitionDecisionPending.getToKnowMarmaladeBody',
                  )}
                </Text>
              </Box>
              <Button
                variant="primary"
                colorScheme="primary"
                size="lg"
                onClick={() => transitionTo('decision_pending_acknowledged')}
              >
                {t(
                  'onboarding:AcquisitionDecisionPending.getToKnowMarmaladeSubmitButton',
                )}
              </Button>
            </Flex>
          </Box>
        )}
      </Flex>
    </Flex>
  )
}

export default Pending
